export const FILE_EXTENSIONS = {
  PDF: 'PDF',
  XLS: 'XLS',
  XLSX: 'XLSX',
  CSV: 'CSV',
} as const;
